// extracted by mini-css-extract-plugin
module.exports = {"collection-container":"home-m__collection-container__3Isby","home-wrapper":"home-m__home-wrapper__3tj-S","header":"home-m__header__1913s"};